/**
 * Get due date styles based on time remaining (overdue, reaching soon, enough time).
 * Used by AllCritiquesCard and CritiqueDetailsHeader for consistent styling.
 *
 * @param {string|Date|null} dueDate - Due date (ISO string, YYYYMMDD, or Date)
 * @returns {{ color: string, backgroundColor: string }}
 */
export const getDueDateStyles = (dueDate) => {
  if (!dueDate) {
    return { color: "#006C9C", backgroundColor: "rgba(0, 184, 217, 0.16)" }; // default
  }

  let dueDateObj;

  if (typeof dueDate === "string") {
    if (/^\d{8}$/.test(dueDate)) {
      const formattedDateStr = `${dueDate.slice(0, 4)}-${dueDate.slice(4, 6)}-${dueDate.slice(6, 8)}`;
      dueDateObj = new Date(formattedDateStr);
    } else {
      dueDateObj = new Date(dueDate);
    }
  } else if (dueDate instanceof Date) {
    dueDateObj = dueDate;
  } else {
    return { color: "#006C9C", backgroundColor: "rgba(0, 184, 217, 0.16)" };
  }

  if (isNaN(dueDateObj.getTime())) {
    return { color: "#006C9C", backgroundColor: "rgba(0, 184, 217, 0.16)" };
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  dueDateObj.setHours(0, 0, 0, 0);

  const diffInDays = Math.ceil((dueDateObj - today) / (1000 * 60 * 60 * 24));

  if (diffInDays < 0) {
    return { color: "#B71D18", backgroundColor: "rgba(255, 86, 48, 0.16)" }; // overdue
  }
  if (diffInDays <= 10) {
    return { color: "#B76E00", backgroundColor: "rgba(255, 171, 0, 0.16)" }; // reaching soon
  }
  return { color: "#006C9C", backgroundColor: "rgba(0, 184, 217, 0.16)" }; // enough time
};
